import { useContext } from 'react';
import { NavLink } from 'react-router-dom';
import { useIntl } from '@edx/frontend-platform/i18n';

import { AppDataContext } from '../../context';
import Newsletter from '../Newsletter';

import './index.scss';
import messages from './messages';

import xTwitterImg from '../../img/footer/x-twitter.png';
import group72Img from '../../img/footer/group-7-2@2x.png';
import logoImg from '../../img/footer/legatum-primary-logo-1-7@2x.png';
import logo2Img from '../../img/footer/legatum-primary-logo-2-6@2x.png';
import logo3Img from '../../img/footer/logo3.png';
import oxfordProjectImg from '../../img/footer/oxford-project.jpg';
import oxfordUniversityImg from '../../img/footer/oxford-university.jpg';
import linkedinImg from '../../img/footer/icon-linkedin-1.svg';
import youtubeImg from '../../img/footer/icon-youtube-3.svg';

const Footer = () => {
  const intl = useIntl();
  const currentYear: number = new Date().getFullYear();
  const { authenticatedUser } = useContext(AppDataContext);

  return (
    <footer className="footer">
      <div className="flex-col-1 flex-col-4 footer-logo-block">
        <a href="/">
          <img className="group-7" src={group72Img} alt="Group 7" />
        </a>
        <div className="footer-custom">
          {intl.formatMessage(messages.jointInitiative)}
        </div>
        <div className="university-logos">
          <NavLink
            target="_blank"
            to="https://www.legatum.com/"
            className="legatum_primary_logo-container d-block"
          >
            <img
              className="legatum_-primary_-logo-1 legatum_-primary_-logo"
              src={logoImg}
              alt="Legatum_Primary_Logo 1"
            />
            <img
              className="legatum_-primary_-logo-2 legatum_-primary_-logo"
              src={logo2Img}
              alt="Legatum_Primary_Logo 2"
            />
          </NavLink>
          <a
            target="_blank"
            href="https://oxfordcharacter.org/"
            className="oxford-logo"
            rel="noreferrer"
          >
            <img
              style={{ height: 75 }}
              className=""
              src={oxfordProjectImg}
              alt=""
            />
          </a>
          <a target="_blank" href="https://www.ox.ac.uk/" className="oxford-logo" rel="noreferrer">
            <img
              style={{ height: 75 }}
              className=""
              src={oxfordUniversityImg}
              alt=""
            />
          </a>
          <a target="_blank" href="https://hfh.fas.harvard.edu/" rel="noreferrer">
            <img
              className=""
              style={{
                height: 75,
                position: 'relative',
                top: 1,
              }}
              src={logo3Img}
              alt="Harvard"
            />
          </a>
        </div>
      </div>
      <div className="flex-col-2 flex-col-4">
        <Newsletter />
        <div className="page-links">
          <div className="flex-col flex">
            <div className="the-programme instrumentsans-normal-white-24px">
              {intl.formatMessage(messages.theProgramme)}
            </div>
            <div className="overview instrumentsans-normal-white-24px">
              <NavLink to="/course-overview">{intl.formatMessage(messages.about)}</NavLink>
            </div>
            <div className="catalog instrumentsans-normal-white-24px">
              <NavLink to="/course-catalogue">{intl.formatMessage(messages.modules)}</NavLink>
            </div>
            {!authenticatedUser && (
              <div className="catalog instrumentsans-normal-white-24px">
                <NavLink to={`/login?redirect-to=${window.location.href}`}>
                  {intl.formatMessage(messages.login)}
                </NavLink>
              </div>
            )}
          </div>
          <div className="flex-col flex">
            <div className="brought-to-you-by instrumentsans-normal-white-24px">
              {intl.formatMessage(messages.broughtToYouBy)}
            </div>
            <div className="oxford instrumentsans-normal-white-24px">
              <a target="_blank" href="https://www.legatum.com/" rel="noreferrer">
                {intl.formatMessage(messages.legatum)}
              </a>{' '}
            </div>
            <div className="harvard-1 instrumentsans-normal-white-24px">
              <a target="_blank" href="https://oxfordcharacter.org/" rel="noreferrer">
                {intl.formatMessage(messages.oxfordCharacterProject)}
              </a>{' '}
            </div>
            <div className="legatum instrumentsans-normal-white-24px">
              <a target="_blank" href="https://hfh.fas.harvard.edu/" rel="noreferrer">
                {intl.formatMessage(messages.humanFlourishing, { lineBreak: <br /> })}
              </a>{' '}
            </div>
          </div>
          <div className="flex-col-3 flex-col-4">
            <div className="support instrumentsans-normal-white-24px">
              {intl.formatMessage(messages.support)}
            </div>
            <div className="place instrumentsans-normal-white-24px">
              {' '}
              <NavLink to="/contact">
                {intl.formatMessage(messages.contact)}
              </NavLink>
            </div>
            <div className="privacy-policy instrumentsans-normal-white-24px">
              <a target="_blank" href="/privacy-policy">
                {intl.formatMessage(messages.privacyPolicy)}
              </a>{' '}
            </div>
            <div className="privacy-policy instrumentsans-normal-white-24px">
              <a target="_blank" href="/terms-of-use">
                {intl.formatMessage(messages.termsOfUse)}
              </a>{' '}
            </div>
          </div>
        </div>
        <div className="flex-row flex copyright-zone">
          <div>
            <p className="copyright-2023-leg instrumentsans-normal-white-12px">
              {intl.formatMessage(messages.copyright, { year: currentYear })}
              <br />
              {intl.formatMessage(messages.trademark)}
            </p>
          </div>
          <div className="socials">
            <a href="https://x.com/LWCcourse" target="_blank" rel="noreferrer">
              <img
                className="vector invert-icon"
                src={xTwitterImg}
                alt="icon/vector"
              />
            </a>
            <a href="https://www.linkedin.com/company/leadingwithcharacter/" target="_blank" rel="noreferrer">
              <img
                className="iconlinkedin"
                src={linkedinImg}
                alt="icon/linkedin"
              />
            </a>
            <a href="https://www.youtube.com/@LeadingWithCharacter" target="_blank" rel="noreferrer">
              <img
                className="iconyoutube"
                src={youtubeImg}
                alt="icon/youtube"
              />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
